import * as z from "zod/v4";

export const getCustomJsSettings = {
  name: "getCustomJsSettings" as const,
  input: z.null(),
  output: z.object({ enabled: z.boolean(), script: z.string() }),
};
